import React, { useContext, useEffect } from 'react'
import { GeneralContext } from '../../context/'
import { connect } from "react-redux"
import { withRouter } from 'react-router-dom'
// import toastr from 'toastr'
// import 'toastr/build/toastr.min.css'

const Index = (props) => {

    const generalContext = useContext(GeneralContext)
    const { setBreadcrumb } = generalContext

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Dashboard`,
            parentLink: '/dashboard',
            item: `Bienvenido/a, ${props.fullName}`
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <React.Fragment>
            <div id="mainContent" className="page mainContent"></div>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return {
        fullName: state.Auth.profile.fullName
    }
}

export default connect(
    mapStatetoProps, {}
)(withRouter(Index))